import React, { useEffect, useRef, useState } from "react";

const MapSection = () => {
  const iframeRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (iframeRef.current) {
        const top = iframeRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight * 0.7) {
          setVisible(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run once on load
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="map-section">
      <div className="map-inner-wrapper py-5">
        <div
          ref={iframeRef}
          className={`map-iframe-wrapper ${visible ? "visible" : ""}`}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3859.5341479649364!2d121.07551527457436!3d14.682358775070778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b0aa67c91a4d%3A0xac813f062cdbbd6a!2s9%20Do%C3%B1a%20Isidora%2C%20Quezon%20City%2C%201127%20Metro%20Manila!5e0!3m2!1sen!2sph!4v1750822574278!5m2!1sen!2sph"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
